import { useState } from "react";

type ProxyImageSrc =
  | { type: "person"; id: number }
  | { type: "garment"; id: number }
  | { type: "person-image"; id: number }
  | { type: "garment-image"; id: number }
  | { type: "generated"; id: number };

interface ProxyImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src"> {
  src: ProxyImageSrc;
}

function buildUrl(src: ProxyImageSrc): string {
  switch (src.type) {
    case "person":
      return `/api/persons/${src.id}/thumbnail`;
    case "garment":
      return `/api/garments/${src.id}/thumbnail`;
    case "person-image":
      return `/api/person-images/${src.id}/proxy`;
    case "garment-image":
      return `/api/garment-images/${src.id}/proxy`;
    case "generated":
      return `/api/images/thumbnail/${src.id}`;
  }
}

export function ProxyImage({ src, alt = "", className, ...rest }: ProxyImageProps) {
  const [failed, setFailed] = useState(false);

  if (failed) return null;

  return (
    <img
      src={buildUrl(src)}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
      {...rest}
    />
  );
}
